import { useQuery } from '@tanstack/react-query'
import type { OrderListItemDTO } from '@wf/shared'
import { api } from '../api/client'
import { OrderCard } from './OrderCard'
import { usePatchOrder } from './useOrders'

/** Archiv-Karte: die Board-Karte plus „Zurückholen" (Archivieren aufheben) direkt aus der Liste. Der Patch
 *  schickt die gelesene `version` (OCC); Erfolg invalidiert das Archiv → der Auftrag verschwindet hier. */
function ArchiveCard({ order }: { order: OrderListItemDTO }) {
  const patch = usePatchOrder(order.id)
  return (
    <div className="wf-archivecard">
      <OrderCard order={order} />
      <button
        type="button"
        className="wf-btn wf-btn--ghost"
        disabled={patch.isPending}
        onClick={() => patch.mutate({ version: order.version, archived: false })}
      >
        Zurückholen
      </button>
    </div>
  )
}

/** Archiv: abgeschlossene Aufträge, aus der aktiven Übersicht genommen, weiter über Kunde/Fahrzeug abrufbar.
 *  Jede Karte lässt sich direkt zurückholen. */
export function ArchivePage() {
  const { data, isLoading, error } = useQuery({ queryKey: ['archive'], queryFn: api.listArchive })

  if (isLoading) return <div className="muted">Archiv wird geladen…</div>
  if (error) {
    return (
      <div className="error" role="alert">
        Archiv konnte nicht geladen werden.
      </div>
    )
  }
  const orders = data?.orders ?? []

  return (
    <section className="wf-view">
      <div>
        <h2 className="viewtitle">Archiv</h2>
        <p className="sub">Abgeschlossene Aufträge · weiter über Kunde/Fahrzeug abrufbar</p>
      </div>
      {orders.length === 0 ? (
        <div className="wf-empty">
          <div className="wf-empty__title">Noch nichts archiviert</div>
          <div className="wf-empty__text">Archivierte Aufträge erscheinen hier.</div>
        </div>
      ) : (
        <div className="wf-cardgrid">
          {orders.map((order) => (
            <ArchiveCard key={order.id} order={order} />
          ))}
        </div>
      )}
    </section>
  )
}
